import { render, staticRenderFns } from "./LectureContentHeader.vue?vue&type=template&id=aaf497d6&"
import script from "./LectureContentHeader.vue?vue&type=script&lang=js&"
export * from "./LectureContentHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports